import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-semibold mb-4 font-[family-name:var(--font-heading)]">
              冲田杏梨粉丝资讯站
            </h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              最全面的冲田杏梨中文资料库，为粉丝提供个人资料、作品全收录、最新动态等一站式信息参考。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-foreground-200">内容分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-foreground-200">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  关于本站
                </Link>
              </li>
              <li>
                <Link to="/category/news" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  最新动态
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-foreground-200">关注我们</h4>
            <div className="flex items-center gap-3">
              <a
                href="https://twitter.com/anri_okita"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a
                href="https://www.instagram.com/anri_okita_official/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 冲田杏梨粉丝资讯站. 本站为非官方粉丝资讯网站，所有内容仅供参考。
          </p>
          <p className="text-xs text-foreground-600">
            本网站与冲田杏梨本人及其经纪公司无直接关联
          </p>
        </div>
      </div>
    </footer>
  );
}